import type { LineStyleOptions, StyleOptions } from '@aus-platform/cesium';
import type { CrossSectionConfig, CrossSectionFormState } from './types';

export const crossSectionFormInitialState: CrossSectionFormState = {
  pointCloudLayer: null,
  workspaceLineLayer: null,
  sampleDistance: '1',
  selectedLine: null,
};

/**
 * Default boundary width for cross-section line visualization (in meters).
 */
export const CROSS_SECTION_DEFAULT_BOUNDARY_WIDTH = 1;

/**
 * Boundary configuration for cross-section lines.
 * @param boundaryWidth - The width of the boundary in meters.
 * @returns The boundary configuration.
 */
export const getBoundaryConfig = (boundaryWidth: number): LineStyleOptions => ({
  boundaryWidth,
  boundaryEnabled: true,
});

/**
 * Base style for drawn lines (yellow with boundary).
 * Applied when drawing a new line in Draw mode.
 */
export const getDrawnLineStyle = (boundaryWidth: number): StyleOptions => ({
  lineStyleOptions: getBoundaryConfig(boundaryWidth),
});

/**
 * Style for selected workspace line (blue highlight with boundary).
 * Applied when a workspace line is clicked for cross-section generation.
 */
export const getSelectedLineStyle = (boundaryWidth: number): StyleOptions => ({
  lineStyleOptions: {
    strokeColor: '#00A8FF',
    boundaryColor: '#00A8FF',
    ...getBoundaryConfig(boundaryWidth),
  },
});

export const initialCrossSectionConfig: CrossSectionConfig = {
  copcCrs: null,
  layerCrs: null,
  targetCrs: null,
  needsCRSFetch: false,
  copcReader: null,
  initializationComplete: false,
  lineData: null,
  copcUrl: null,
  pathWGS84: null,
  buffer: null,
};
